<template>
    <div
        class="flex items-center gap-3">
        <hts-form-input
            v-model="hours"
            class="w-32"
            :min="0"
            number-interger
            type="number">
            <template #suffix>
                <span class="text-black">
                    giờ
                </span>
            </template>
        </hts-form-input>
        <span class="font-bold">
            :
        </span>
        <hts-form-input
            v-model="minutes"
            class="w-32"
            :min="0"
            :max="59"
            number-interger
            type="number">
            <template #suffix>
                <span class="text-black">
                    phút
                </span>
            </template>
        </hts-form-input>
    </div>
</template>

<!-- @change="(val: number) => positions[index].travelTimeToNextPosition.duration = val * 3600"> -->
<script setup lang="ts">
const hours = ref(0)
const minutes = ref(0)

const props = defineProps({
  value: {
    type: Number,
    required: true
  },
  type: {
    type: String,
    default: 'hour'
  }
})

const {
  value, type
} = toRefs(props)

onMounted(() => {
  if (typeof cValue.value !== 'number') {
    return ''
  }

  let hoursT: number
  let minutesT: number

  if (type.value === 'hour') {
    hoursT = Math.floor(cValue.value)
    minutesT = Math.floor((cValue.value - hoursT) * 60)
  } else if (type.value === 'minute') {
    minutesT = Math.floor(cValue.value)
    hoursT = Math.floor(minutesT / 60)
    minutesT = minutesT % 60
  } else if (type.value === 'second') {
    minutesT = Math.floor(cValue.value / 60)
    hoursT = Math.floor(minutesT / 60)
  } else {
    return ''
  }

  hours.value = hoursT
  minutes.value = minutesT
})

const emits = defineEmits(['update'])

watch(() => hours.value, () => update())
watch(() => minutes.value, () => update())

const cValue = computed<number>({
  get: () => {
    return value.value
  },
  set: (val) => {
    emits('update', val)
  }
})

const update = () => {
  const t = data()
  cValue.value = t
}

const data = () => {
  if (type.value === 'hour') {
    return hours.value + (minutes.value ? minutes.value / 60 : 0)
  } else if (type.value === 'minute') {
    return hours.value * 60 + minutes.value
  } else if (type.value === 'second') {
    return hours.value * 3600 + minutes.value * 60
  }

  return 0
}
</script>
